module.exports = __webpack_public_path__ + "img/chemi.38f5bd4b.svg";